/**
 * Cache côté client (module-level) pour les pages à chargement lourd.
 * Persiste entre les montages/démontages de composants React.
 * TTL : 10 minutes — au-delà, la donnée est considérée périmée.
 */

const CACHE = new Map();
const TTL_MS = 10 * 60 * 1000; // 10 minutes

export const pageCache = {
  /**
   * Récupère les données en cache. Retourne null si absent ou expiré.
   */
  get(key) {
    const entry = CACHE.get(key);
    if (!entry) return null;
    if (Date.now() - entry.ts > TTL_MS) {
      // Ne pas supprimer — garder pour getOrStale()
      return null;
    }
    return entry.data;
  },

  /**
   * Stale-While-Revalidate : retourne les données même périmées, avec un flag.
   * Permet d'afficher les anciennes données pendant le rechargement silencieux.
   */
  getOrStale(key) {
    const entry = CACHE.get(key);
    if (!entry) return { data: null, isStale: false };
    const isStale = Date.now() - entry.ts > TTL_MS;
    return { data: entry.data, isStale };
  },

  /**
   * Stocke les données avec un timestamp.
   */
  set(key, data) {
    CACHE.set(key, { data, ts: Date.now() });
  },

  /**
   * Invalide une entrée (à appeler après une mutation pour forcer le rechargement).
   */
  delete(key) {
    CACHE.delete(key);
  },

  /**
   * Invalide toutes les entrées dont la clé commence par un préfixe donné.
   */
  deleteByPrefix(prefix) {
    for (const k of CACHE.keys()) {
      if (k.startsWith(prefix)) CACHE.delete(k);
    }
  },
};
